import React, {Component} from 'react';
import PrintPreview from '../PrintPreview'
import ReportStore from 'stores/ReportStore'
import './Print.css'

const DEFAULT_ROW = 41
class PrintReportWorking extends Component {

    constructor(...args) {
      super(...args)
        
      this.state = {loading:false,dataList:[],data:[],report_title:'กำลังดึงข้อมูล..'}

      var cssPagedMedia = (function() {
        var style = document.createElement('style');
        document.head.appendChild(style);
        return function (rule) {
          style.innerHTML = rule;
        };
      }());
  
      cssPagedMedia.size = function(size) {
        cssPagedMedia('@page {size: ' + size + '}');
      };
      cssPagedMedia.size('portrait');
    }

    componentDidMount() {
        this.loadData()
    }

    loadData() {
        if (this.props.isRange=='false'&&this.props.year!=undefined&&this.props.month!=undefined&&this.props.type!=undefined) {
            ReportStore.loadKpi(this.props.year,this.props.month,this.props.type,(result)=>{
                this.setState({data:result.data,dataList:this.getPagination(result.data),report_title:'ไม่พบข้อมูล'})
            },()=>{

            })   
        } else if (this.props.isRange=='true'&&this.props.startDate!=undefined&&this.props.endDate!=undefined&&this.props.type!=undefined) {
            ReportStore.loadKpiRange(this.props.startDate,this.props.endDate,this.props.type,(result)=>{
                this.setState({data:result.data,dataList:this.getPagination(result.data),report_title:'ไม่พบข้อมูล'})
            },()=>{
                
            })
        } else {
            this.setState({data:[],dataList:this.getPagination([]),report_title:'ไม่พบข้อมูล'})
        }
    }

    getNumberFormat(value,digit=2) {
        let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
        _val = parseFloat(_val)
        return _val.toFixed(digit).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
    }

    getSummary(field) {
        let {data} = this.state
        let total = 0
        data.forEach((item,index)=> {
            total += (item[field]===''||item[field]===null||item[field]===undefined||isNaN(item[field])?0:item[field]*1)
        }) 
        return total
    }

    getPagination(data) {
        let newData = []
        let allData = []
        let checkRow = 0
        data.forEach(function(item,index) {
            if (checkRow<DEFAULT_ROW)
              checkRow++
              newData.push(item)
    
            if (checkRow===DEFAULT_ROW-1||index===data.length-1) {
              allData.push(newData)
              checkRow = 0
              newData = []
            }
        })  
        
        return allData
    }

    renderRowData(data,indexs) {
        if (data.length==0) {
          return(<tr><td colSpan={8}>ไม่พบข้อมูล</td></tr>)
        } else {
          return data.map((item, index) => (
            <tr key={index}>
                <td className='text-center'>{(indexs*40)+index+1}</td>
                <td className='text-center'>{item.employee_id}</td>
                <td className='text-center'>{item.employee_name}</td>
                <td className='text-center'>{item.task_name}</td>
                <td className='text-center'>{item.task_count}</td>
                <td className='text-center'>{item.tasklate_count}</td>
                <td className='text-center'>{item.taskopen_count}</td>
                <td className='text-right'>{this.getNumberFormat(item.amount)}</td>
            </tr>
          ))
        }
    }

    renderTable(item,index,length) {
        // let {type} = this.props
        return(
            <table className='table table-print-report-commission-mechanic'>
                <tbody>
                    <tr>
                        <td className='text-center' style={{width:'50px'}}>ลำดับ</td>
                        <td className='text-center' style={{width:'150px'}}>รหัสพนักงาน</td>
                        <td className='text-center' style={{width:'300px'}}>ชื่อนามสกุล</td>
                        <td className='text-center' style={{width:'100px'}}>งานในระบบ</td>
                        <td className='text-center' style={{width:'100px'}}>จำนวนงาน</td>
                        <td className='text-center' style={{width:'100px'}}>งานล่าช้า</td>
                        <td className='text-center' style={{width:'100px'}}>งานที่ยังเปิดอยู่</td>
                        <td className='text-center' style={{width:'100px'}}>มูลค่างานซ่อม</td>
                    </tr>
                    {this.renderRowData(item,index)}
                    {length-1===index?
                    <tr>
                        <td colSpan={4} className='text-right'>ยอดรวมสุทธิ</td>
                        <td className='text-center'>{this.getNumberFormat(this.getSummary('task_count'),0)}</td>
                        <td className='text-center'>{this.getNumberFormat(this.getSummary('tasklate_count'),0)}</td>
                        <td className='text-center'>{this.getNumberFormat(this.getSummary('taskopen_count'),0)}</td>
                        <td className='text-right'>{this.getNumberFormat(this.getSummary('amount'))}</td>
                    </tr>
                    :''}
                </tbody>
            </table>
        )
    }

    renderComponentPage(item,index,length) {
        return(  
            <div className='font-print' key={index}>
                <header className="text-center">
                    <h2>{this.props.type=='office'?this.props.title:'ตารางรายงานการปฏิบัติงานของช่าง'}</h2>
                </header>
                <div>
                    {this.renderTable(item,index,length)}
                </div>
            </div>
        )    
    }
    
    renderNoData() {
        return(
          <div className='font-print'>
            <header className="text-center">
              <h2>{this.state.report_title}</h2>
            </header>
          </div>
        )
    }

    render() {
        let {loading,dataList} = this.state
        if (dataList.length==0) {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={this.props.type=='office'?this.props.title:'ตารางรายงานการปฏิบัติงานของช่าง'}
                >
                    {this.renderNoData()}    
                </PrintPreview>
            )
        } else {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={this.props.type=='office'?this.props.title:'ตารางรายงานการปฏิบัติงานของช่าง'}
                >
                    {
                        dataList.map((item,index)=>{
                            return(
                                this.renderComponentPage(item,index,dataList.length)
                            )
                        })   
                    }
                </PrintPreview>
            )
        }      
    }
}

PrintReportWorking.defaultProps = {
    title: 'ตารางรายงานการปฏิบัติงานของออฟฟิศ',  
    mode: '',
    workNo: '',
    type: 'office',
    fullname: '',
    taskclosed: '',
    taskamount: ''
  }
  export default PrintReportWorking;


// WEBPACK FOOTER //
// ./src/view/print/employee/PrintReportWorking.js